<div [formGroup]="form">
  <div class="tw-flex tw-flex-col tw-gap-1"
  *ngIf="campaignType!== CampaignTypeEnumm['Interactive Tour']">
    <div class="tw-text-grey-950 tw-text-lg tw-font-bold tw-leading-6">
      Recognition Details
    </div>
    
  </div>
  <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4 tw-pt-5"
  *ngIf="campaignType!== CampaignTypeEnumm['Interactive Tour']"
  >
    <div class="sml-control-group tw-col-span-1"
    [ngClass]="{
      '!tw-col-span-2' :campaignType=== CampaignTypeEnumm['Sponsorship'] || campaignType=== CampaignTypeEnumm['Registration']
    }"
    >
      <label for="donatedBy" class="sml-light-label">{{getDonatedByName()}}</label>
      <input
        type="text"
        id="donatedBy"
        formControlName="donatedBy"
        [placeholder]="getDedicatedToNamePlaceholder()"
        class="sml-control"
      />
    </div>
    <div class="sml-control-group tw-col-span-1"
    *ngIf="campaignType!== CampaignTypeEnumm['Registration']"
    [ngClass]="{
      '!tw-col-span-2' : campaignType=== CampaignTypeEnumm['Sponsorship']
    }">
      <label for="dedicatedTo" class="sml-light-label">{{getDedicatedToName()}}</label>
      <input
        type="text"
        id="dedicatedTo"
        formControlName="dedicatedTo"
        [placeholder]="getDonatedByNamePlaceholder()"
        class="sml-control"
      />
    </div>
  </div>

  <div class="sml-control-group tw-col-span-2 tw-pt-4">
    <div class="tw-text-grey-950 tw-text-lg tw-font-bold tw-leading-6">
      Attach QR Plaque
    </div>
   
    <label for="selectqRPlaque" class="sml-label tw-pt-3">Select QR Plaque <sup *ngIf="isQrPlaqueRequired" class="tw-text-alert-800">*</sup></label>
    <sml-search-dropdown formControlName="qrPlaque" [items]="plaques" [placeholder]="'Search & Select QR Plaque'" [position]="'top'" (controlTouched)="onControlTouched()" (controlDirty)="onControlDirty()" [isInvalid]="control['qrPlaque'].invalid && (control['qrPlaque'].dirty || control['qrPlaque'].touched)" ></sml-search-dropdown>
    <div class="sml-form-error" *ngIf="control['qrPlaque'].invalid && (control['qrPlaque'].dirty || control['qrPlaque'].touched)">
      <p *ngIf="control['qrPlaque'].errors?.['required']" class="tw-text-alert-800">
        QR Plaque is required.
      </p>
    </div>
  </div>
</div>
<div class="tw-font-medium tw-text-base tw-text-mercury-950 tw-pt-5">
  Want to buy more plaques? No worries! Click here to 👉🏼
  <a href="{{storyPlaqueBuyUrl}}" target="_blank" class="tw-font-bold tw-text-primary-700 tw-cursor-pointer"
    >Buy now.</a>
</div>
